import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";

import "./global.css";
import { AuthProvider, ProtectedRoute } from "@/auth/context";
import { Instances } from "@/routes/instances.tsx";
import Callback from "@/routes/authn/callback.tsx";
import Login from "@/routes/authn/login.tsx";
import { Settings } from "@/routes/settings.tsx";
import StreamPage from "@/routes/stream.tsx";
import { Toaster } from "@/components/ui/toaster";

import "./utils/zaraz-init.ts";
import CLILogin from "@/routes/authn/cli.tsx";
import { InvitationDialog } from "@/components/InvitationDialog";

const ProtectedLayout = () => {
  return (
    <>
      <InvitationDialog />
      <Outlet />
    </>
  );
};

export const App = () => {
  console.log({ commit: import.meta.env.VITE_COMMIT });
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/authn/login" element={<Login />} />
          <Route path="/authn/callback" element={<Callback />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<StreamPage />} />
              <Route path="/authn/cli" element={<CLILogin />} />
              <Route path="/instances" element={<Instances />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/stream/:instanceId?" element={<StreamPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>
        </Routes>
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  );
};

// biome-ignore lint/style/noNonNullAssertion: It's how React works.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
